/**
 * Throws a missing parameter error
 */
export default function throwIfMissing() {
  throw new Error("Missing parameter");
}
//# sourceMappingURL=throwIfMissing.js.map